import {
  FC,
  ReactNode,
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";
import * as apiClient from "../api";
import { LinearProgress } from "@mui/material";
import { Question } from "../types";

const HistoryQuestionsContext = createContext<Question[]>([]);

export const useHistoryQuestionsContext = () =>
  useContext(HistoryQuestionsContext);

export const HistoryQuestionsProvider: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [loaded, setLoaded] = useState(false);
  const [questions, setHistoryQuestions] = useState<Question[]>([]);

  useEffect(() => {
    const loadHistoryQuestions = async () => {
      const result = await apiClient.getHistoryQuestions();
      setHistoryQuestions(result.data.questions);
      setLoaded(true);
    };
    loadHistoryQuestions();
  }, []);

  return (
    <HistoryQuestionsContext.Provider value={questions}>
      {loaded ? children : <LinearProgress />}
    </HistoryQuestionsContext.Provider>
  );
};
